<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Job Issue'"
      [canGoBack]="true"
      [customBack]="'job-issue-detail'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (loaded) {
      <tidy-card>
        <tidy-row>
          <tidy-text
            [body]="'This job on'" /><span>&nbsp;</span>
            <tidy-text
          [body]="(job?.job?.date | parseDateTime: 'ddd') + ' ' + (job?.job?.date | parseDateTime: 'MMM d')" /><span>&nbsp;</span>
              <tidy-text
                [body]="'at'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="job?.job?.start_time | parseDateTime: 'h:mma'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'was marked as complete by the pro'" /><span>&nbsp;</span>
                    <tidy-text
                      [body]="job?.homekeepers[0].first_name" />
                    <tidy-text
                      [body]="'. What is your issue?'" />
                  </tidy-row>
                  <tidy-row class="extra-bottom-padding">
                    <tidy-text
          [body]="('You left them a negative review. ' | translate) + negativeReviewSentence + ('What is your issue?' | translate)" />
                  </tidy-row>
                  <tidy-card-button (action)="selectIssue('negative_review.additional_protection', 'Additional Protection Purchased')">
                    <tidy-row>
                      <tidy-text
                        [body]="'I purchased additional protection, and this was not reflected.'" />
                    </tidy-row>
                  </tidy-card-button>
                  <tidy-card-button (action)="advancedDispute('I\'m Not Satisfied')">
                    <tidy-row>
                      <tidy-text
                        [body]="('I\’m not satisfied and want to dispute this directly with ' | translate) + job?.homekeepers[0].first_name + '.'" />
                    </tidy-row>
                  </tidy-card-button>
                </tidy-card>
              }

            </tidy-wrapper>
          </ng-template>

          @if (!isRightSideContent) {
            <app-scroll-wrapper [templateContent]="content" />
          }

          @if (isRightSideContent) {
            <ion-content class="ion-content-right-column">
              <ng-container *ngTemplateOutlet="content" />
            </ion-content>
          }

